<template>
  <PostV3
    v-if="this.uiVersion == 3"
    :guid="post.guid"
    :title="this.formattedTitle"
    :featuredImageUrl="this.featuredImageUrl"
    :formattedDate="this.formattedDate"
    :formattedDescription="this.formattedDescription"
  />

  <PostV2
    v-else-if="this.uiVersion == 2"
    :guid="post.guid"
    :title="this.formattedTitle"
    :featuredImageUrl="this.featuredImageUrl"
    :formattedDate="this.formattedDate"
    :formattedDescription="this.formattedDescription"
  />
</template>
<script>
import he from "he";
import PostV3 from "./Posts/PostV3.vue";
import PostV2 from "./Posts/PostV2.vue";
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  components: { PostV3, PostV2 },
  methods: {
    truncateString: function (str, len) {
      if (str.length <= len) {
        return str;
      }
      return str.slice(0, len) + "...";
    },
    decodeHtmlEntities: function (str) {
      return he.decode(str);
    },
  },
  computed: {
    featuredImageUrl: function () {
      return "https://blog.roll20.net" + this.post.featuredImage;
    },
		formattedTitle: function () {
			return this.decodeHtmlEntities(this.post.title)
		},
    formattedDate: function () {
      return Intl.DateTimeFormat(navigator.language, {
        month: "short",
        day: "numeric",
        year: "numeric",
      }).format(new Date(this.post.pubDate));
    },
    formattedDescription: function () {
      let truncated = this.truncateString(this.post.description, 100);
      // We need to decode twice
      // Example "Who&amp;rsquo;s ready to get thirsty?!"
      // First pass results in "Who&rsqou;s ready..." (converts ampersand)
      // Second pass converts the quote "Who's ready..."
      let decodedFirstPass = this.decodeHtmlEntities(truncated);
      return this.decodeHtmlEntities(decodedFirstPass);
    },
  },
};
</script>